import { useAuthContext } from '@/modules/Auth/Auth.context';
import { getIndexRoute } from '@/modules/Router/Router.utils';
import { Navigate } from 'react-router-dom';

export const IndexRoute = () => {
  const { userGroups } = useAuthContext();
  return <Navigate to={getIndexRoute(userGroups)} replace />;
};
